import { render, staticRenderFns } from "./BaseActivityDetails.vue?vue&type=template&id=30af5b36&scoped=true&"
import script from "./BaseActivityDetails.vue?vue&type=script&lang=js&"
export * from "./BaseActivityDetails.vue?vue&type=script&lang=js&"
import style0 from "./BaseActivityDetails.vue?vue&type=style&index=0&id=30af5b36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30af5b36",
  null
  
)

export default component.exports